import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { SocketService } from 'src/app/services/socket.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.page.html',
  styleUrls: ['./users.page.scss'],
})
export class UsersPage implements OnInit, OnDestroy {

  userList: any[];
  userListFiltered: any[];
  userListLength: number;
  searchText: string = '';

  sortType: string = 'username';

  selectedCategory: number = 0;
  userCategories: any[] = [];
  loadProfile: number;

  selectedUser: any;
  user: any;

  socketEventListeners: any = {};
  
  constructor(
    private menuCtrl: MenuController,
    private userService: UserService,
    private socketService: SocketService,
    private changeDetection: ChangeDetectorRef,
    private route:ActivatedRoute) { }

  ngOnInit() {

    this.menuCtrl.enable(true);

    this.initializeUsers();

    this.userListLength = 0;

    this.route.queryParams.subscribe((e) => {
      if(e && e.profile) {
        this.loadProfile = parseInt(e.profile);

        if (this.userListFiltered && this.userListFiltered.length > 0) {
          this.selectUser(this.userListFiltered.find(u => u.id === this.loadProfile));
          this.loadProfile = null;
        }
      }
    });
  }

  ngOnDestroy(): void {
    for (const [evt, listener] of Object.entries(this.socketEventListeners)) {
      this.socketService.unsubscribe(evt, listener);
    }
  }

  initializeUsers() {

    if (this.userService.currentUser && this.userService.currentUser.username && this.userService.userCategories.length > 0) {

      this.userCategories = this.userService.userCategories;
      this.userService.currentUser$.subscribe(next => {
        this.user = next;        
      });
      
      this.refreshUserList();
      this.initSocketSubscriptions();
    }
    else{
      setTimeout(()=>this.initializeUsers(),1000);
    }
  }

  refreshUserList() {
    
    if (this.user?.is_member) {
      this.userService.getUserList().subscribe(res => {
        if (!res.error) {
          this.userList = res.list;

          this.updateFilteredList();

          if (this.loadProfile) {
            this.selectUser(this.userListFiltered.find(u => u.id === this.loadProfile));
          }
        }
      });
    }
    else {
      this.userList = [];
      this.updateListUser(this.user.id);
    }
  }

  updateListUser(userId) {

    this.userService.getUser(userId).subscribe(res => {
      if (!res.error && res.user) {
        let idx = this.userList.findIndex(u => u.id === res.user.id)

        if (idx >= 0) {
          this.userList[idx] = res.user;
        }
        else {
          this.userList.push(res.user);
        }
        
        this.updateFilteredList();    
        
        if (this.loadProfile) {
          this.selectUser(this.userListFiltered.find(u => u.id === this.loadProfile));
        }

        this.changeDetection.detectChanges();
      }
    })    
  }

  updateFilteredList() {

    let searchText = this.searchText.toLowerCase();

    this.userListFiltered = this.userList.filter(usr => {
      return ((!this.selectedCategory || this.selectedCategory == 0 || usr.category_id == this.selectedCategory)
        && (searchText == '' || (usr.username+'_'+usr.email+'_'+usr.company_name+'_'+usr.job_title).toLowerCase().indexOf(searchText) >= 0));
    });

    this.userListFiltered.sort((a,b) => {
      if (this.sortType == 'created_at') {
        return (a.created_at > b.created_at ? -1 : 1);
      }
      else {
        return (a.username > b.username ? 1 : -1);
      }
    });      
  }

  public userTrackBy(index: number, item: any) {
    return item.updated_at;
  }

  initSocketSubscriptions() {

    //Set socket event listener for user created
    this.socketEventListeners[`userCreated`] = (data) => {
      console.log('SOCKET MESSAGES -> userCreated', data);
      this.updateListUser(data.userId);
    }

    //Set socket event for user updated
    this.socketEventListeners[`userUpdated`] = (data) => {
      console.log('SOCKET MESSAGES -> userUpdated', data);
      this.updateListUser(data.userId);
    }
    
    for (const [evt, listener] of Object.entries(this.socketEventListeners)) {
      this.socketService.subscribe(evt, listener);
    }
  }

  switchUsersSort() {
    if (this.sortType == 'created_at') {
      this.sortType = 'username';
    }
    else {
      this.sortType = 'created_at';
    }

    this.updateFilteredList()
  }

  selectCategory(ev) {
    this.selectedCategory = ev.target.value;
    this.updateFilteredList();
  }

  searchUsers(ev) {
    console.log('search', ev.target.value);
    this.searchText = ev.target.value.toLowerCase();
    this.updateFilteredList();
  }

  selectUser(usr) {
    this.selectedUser = Object.assign({}, usr);
  }
}
